import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const Google: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 12.2042C21 11.566 20.9416 10.9524 20.833 10.3633H12.1837V13.8446H17.1262C16.9133 14.9696 16.2662 15.9228 15.2936 16.561V18.8192H18.2616C19.9981 17.2524 21 14.9451 21 12.2042Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1836 21.0005C14.6632 21.0005 16.7421 20.1945 18.2616 18.82L15.2936 16.5618C14.4712 17.1018 13.4193 17.4209 12.1836 17.4209C9.7917 17.4209 7.76711 15.8377 7.04494 13.7104H3.97675V16.0423C5.48788 18.9836 8.59364 21.0005 12.1836 21.0005Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.045 13.7103C6.86133 13.1703 6.75697 12.5935 6.75697 12.0003C6.75697 11.4071 6.86133 10.8303 7.045 10.2903V7.9585H3.97681C3.35482 9.1735 3 10.548 3 12.0003C3 13.4526 3.35482 14.8271 3.97681 16.0421L7.045 13.7103Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1836 6.57955C13.532 6.57955 14.7425 7.03364 15.6943 7.92546L18.3284 5.34409C16.7379 3.89182 14.6591 3 12.1836 3C8.59364 3 5.48788 5.01682 3.97675 7.95818L7.04494 10.29C7.76711 8.16273 9.7917 6.57955 12.1836 6.57955Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Google;
